import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as result from '../result'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: result.RESOURCE.payload.dimension.partialId,
      partialId: result.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'pass or fail for the latest test run; null until CI finishes.',
    isOptional: true,
    name: 'Test Outcome',
    partialId: PartialId.Standard.create('test_outcome'),
    type: {
      enumId: core.dms.models.Enum.Id.from(enums.testOutcome.RESOURCE.payload),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
